<template>
    <div>
        <el-dialog :title="title" :visible.sync="show" width="65%" :close-on-click-modal="false"
            :modal-append-to-body='true'>
            <!-- 填写基础信息 -->
            <el-form ref="receipForm" :model="receipForm" label-width="120px" style="width: 100%" :rules="rules">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="子加工单" prop="subtaskOrder" v-if="enableSubOrder">
                            <el-input v-model="receipForm.subtaskOrder" type="text" placeholder="请输入子加工单" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="订单" prop="orderNo">
                            <el-input :disabled="true" v-model="receipForm.orderNo" type="text" placeholder="请输入订单" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="产品编码" prop="productCode">
                            <el-select :disabled="true" v-model="receipForm.productCode" style="width: 100%"
                                placeholder="请输入产品名称模糊匹配或者下拉选择" :remote-method="getproductlist" filterable remote
                                :loading="productloading">
                                <el-option v-for="item in productlist" :key="item.product_code" :label="item.product"
                                    :value="item.product_code" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :offset="1" :span="5">
                        <el-button v-permission="['orderlist_select']" type="primary" icon="el-icon-search"
                            @click="search">搜索
                        </el-button>
                        <el-button @click="resetForm('searchform')">重置</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-table id="parent" v-loading="listLoading" :stripe="true" element-loading-text="拼命加载中" :data="tableData"
                style="width: 100% " :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }" border
                :default-sort="{ prop: 'produce_time', order: 'descending' }" max-height="700">
                <el-table-column v-for="item in tablecolumn" :key="item.key" :prop="item.key" :label="item.label"
                    :fixed="item.key == 'cz' ? 'right' : false" :min-width="item.width">
                </el-table-column>
                <af-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="listId != scope.row.id" class="bottstycz" v-permission="['orderlist_delete']"
                            type="danger" @click="deletedate(scope.row.id)">
                            迁移数据
                        </el-button>
                    </template>
                </af-table-column>
            </el-table>
            <el-pagination background :current-page.sync="currentPage" :page-sizes="[10, 20, 50, 100]"
                layout="total,prev, pager, next,jumper,sizes" :total="total_count" @current-change="currentchange"
                @size-change="pagesize" />
            <div style="text-align: center">
                <el-button style="margin-top: 12px" @click="resetForm()">取消</el-button>
                <!-- <el-button style="margin-top: 12px" @click="submitadd('receipForm')" type="primary">提交</el-button> -->
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    orderquery,
    updateqrcodeworkorder,
} from "@/api/plant";
import { productlist } from "@/api/base";
import store from "@/store";
export default {
    props: {
        search: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            enableSubOrder: store.state.user.enable_sub_order,
            tableData: [],
            listLoading: false,
            productloading: false,
            //基础数据
            show: false,
            total_count: 1,
            currentPage: 1,
            receipForm: {
                orderNo: null,
                subtaskOrder: null,
                productCode: null,
                id: null,
                pageSize: 10,
                pageIndex: 1
            },
            title: '数据迁移',
            productlist: [],
            rules: {
                workorderSeniorOrder: [
                    { required: true, message: "请选择生产工单", trigger: "change" },
                ],
            },
            listId: null,
            tablecolumn: [
                // {
                //     label: "工厂",
                //     key: "factory_code",
                //     width: "130",
                // },
                // {
                //     label: "车间",
                //     key: "workshop_code",
                //     width: "130",
                // },
                // {
                //     label: "产线",
                //     key: "workline_code",
                //     width: "100",
                // },
                // {
                //     label: "班组",
                //     key: "workgroup_code",
                //     width: "100",
                // },
                {
                    label: "订单",
                    key: "orderno",
                    width: "150",
                },
                {
                    label: "产品",
                    key: "product_name",
                    width: "230",
                },
                {
                    label: "规格",
                    key: "specs",
                    width: "80",
                },
                {
                    label: "计划生产数量",
                    key: "product_quantity",
                    width: "120",
                },
                {
                    label: "人工确认数量",
                    key: "reality_instorage_count",
                    width: "120",
                },
                {
                    label: "批次号",
                    key: "batchno",
                    width: "160",
                },
                {
                    label: "有效期",
                    key: "period_date",
                    width: "160",
                },
                {
                    label: "计划开始时间",
                    key: "produce_time",
                    width: "140",
                },
                {
                    label: "计划结束时间",
                    key: "complete_time",
                    width: "140",
                },
                {
                    label: "生产状态",
                    key: "statusname",
                    width: "100",
                },
                {
                    label: "质检状态",
                    key: "quality_statusmean",
                    width: "100",
                },
            ],
        };
    },
    mounted() {
        if (this.enableSubOrder) {
            this.tablecolumn.unshift(
                {
                    label: "子加工单",
                    key: "subtask_order",
                    width: "170",
                },
            )
        }
    },
    methods: {
        // 修改明细
        getoutbilldata(row) {
            this.getproductlist()
            console.log(row, 'row');
            this.listId = row.id
            this.receipForm = {
                orderNo: row.orderno,
                subtaskOrder: row.subtask_order,
                productCode: row.product_code,
                // id: row.id,
                pageSize: 10,
                pageIndex: 1
            }
            this.Tabledata()
            console.log(this.receipForm, 'receipForm');
            this.show = true
        },
        // 清空表单数据
        resetForm() {
            this.receipForm = {}
            this.show = false;
        },
        // 获取产品下拉
        getproductlist(value) {
            this.productlist = [];
            if (value !== "") {
                this.productloading = true;
                setTimeout(() => {
                    this.productloading = false;
                    productlist({ productName: value }).then((response) => {
                        this.productlist = response.data.data;
                        for (var i = 0; i < this.productlist.length; i++) {
                            this.productlist[i].product =
                                this.productlist[i].product_code +
                                "   " +
                                this.productlist[i].product_name;
                        }
                    });
                }, 200);
            } else {
                this.productlist = [];
            }
        },
        Tabledata() {
            // 列表获取
            this.listLoading = true;
            orderquery(this.receipForm).then((response) => {
                this.tableData = response.data.data;
                this.packdate(this.tableData);
                this.currentPage = response.data.page_index;
                this.total_count = response.data.total_count;
                this.listLoading = false;
            });
        },
        // 分页每页显示条数事件
        pagesize(page_size) {
            this.receipForm.pageSize = page_size;
            this.Tabledata();
        },
        // 分页跳转事件
        currentchange(page_index) {
            this.receipForm.pageIndex = page_index;
            this.Tabledata();
        },
        // 删除按钮事件
        deletedate(id) {
            this.$confirm("是否确认迁移数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateqrcodeworkorder({
                        OldWorkorderID: this.listId,
                        NewWorkorderID: id
                    }).then((response) => {
                        this.$message({
                            type: "success",
                            message: "迁移成功!",
                        });
                        this.Tabledata();
                    });
                })
        },
        packdate(obj) {
            // 拼表格数据
            obj.forEach(item => {
                item.harvest_rate1 = item.package_level1_produce == 0 ? '0%' : `${(item.package_level1_count / item.package_level1_produce * 100).toFixed(2)}%`;
                item.harvest_rate2 = item.package_level2_produce == 0 ? '0%' : `${(item.package_level2_count / item.package_level2_produce * 100).toFixed(2)}%`;
                item.harvest_rate3 = item.package_level3_produce == 0 ? '0%' : `${(item.package_level3_count / item.package_level3_produce * 100).toFixed(2)}%`;
                item.harvest_rate4 = item.package_level4_produce == 0 ? '0%' : `${(item.package_level4_count / item.package_level4_produce * 100).toFixed(2)}%`;
                item.harvest_rate5 = item.package_level5_produce == 0 ? '0%' : `${(item.package_level5_count / item.package_level5_produce * 100).toFixed(2)}%`;

                if (item.min_package_unit_name) {
                    item.product_quantity =
                        item.product_quantity + item.product_unit_cn;
                }

                // 把数据按规则拼起来  +'-' (item.factory_sub_code||" ")
                item.produce_time = this.$parseTime(item.produce_time);
                item.complete_time = item.complete_time.replace(/T/, " ");
                item.plan_date = item.plan_date.replace(/T/, " ");
                item.plan_datetime1 = item.plan_datetime1.replace(/T/, " ");
                item.plan_datetime2 = item.plan_datetime2.replace(/T/, " ");
                item.factory_code =
                    (item.factory_code || " ") +
                    " " +
                    (item.factory_sub_code || " ") +
                    " " +
                    (item.factory_name || " ");
                item.workshop_code =
                    (item.workshop_code || " ") + (item.workshop_name || " ");
                item.workgroup_code =
                    (item.workgroup_code || " ") + (item.workgroup_name || " ");
                item.workline_code =
                    (item.workline_code || " ") + (item.workline_name || " ");
                item.product_name =
                    (item.product_code || " ") + " " + (item.product_name || " ");
                item.supplier_id = (item.supplier_id || " ") + (item.supplier_name || " ");
                if (item.period_date == "0001-01-01") {
                    item.period_date = " ";
                }
                // 状态为已完成 才有完成时间
                if (item.order_status !== 4) {
                    item.complete_time = " ";
                }
                if (item.order_status < 3) {
                    // 未生产  生产时间为空
                    item.produce_time = " ";
                }
                switch (item.quality_status) {
                    case 0:
                        item.quality_statusmean = "待质检";
                        break;
                    case 1:
                        item.quality_statusmean = "检验不合格";
                        break;
                    case 2:
                        item.quality_statusmean = "检验合格";
                        break;
                    case 3:
                        item.quality_statusmean = "临时放行";
                        break;
                }
                switch (item.order_status) {
                    case 1:
                        item.statusname = "未下载";
                        break;
                    case 2:
                        item.statusname = "已下载";
                        break;
                    case 3:
                        item.statusname = "生产中";
                        break;
                    case 4:
                        item.statusname = "已完成";
                        break;
                    case 9:
                        item.statusname = "已关闭";
                        break;
                    default:
                        break;
                }
            })
        },
    },
    // 搜索事件
    search() {
        this.Tabledata();
    },
};
</script>

<style></style>